import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Button, Divider, Typography } from "@mui/material";

import { useUserTrophies } from "../../../User/api/queries/useUserTrophies";
import { getPlayerTrophiesRoute } from "../../../../routers/routeUtils";

import { TrophyCard } from "./TrophyCard";
import { TrophiesLoader } from "./TrophiesLoader";
import EmptyTrophies from "./EmptyTrophies";
import { styles } from "./styles";

const Trophies = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "trophies" });
  const { userId } = useParams();
  const navigate = useNavigate();
  const { data: trophiesData, isLoading: isTrophiesLoading, isError: isTrophiesError } = useUserTrophies(userId!, 5);

  if (isTrophiesLoading) return <TrophiesLoader />;
  if (isTrophiesError || !trophiesData?.length) return <EmptyTrophies />;

  const handleOnClickShowMore = () => {
    navigate(getPlayerTrophiesRoute(userId!));
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.contentWrapper}>
        <Typography sx={styles.title}>{t("trophies")}</Typography>
        <Box sx={styles.trophyGrid}>
          {(trophiesData || []).map((trophy) => (
            <TrophyCard key={trophy.id} trophy={trophy} />
          ))}
        </Box>
      </Box>
      <Divider orientation="horizontal" />
      <Button variant="text-sm" fullWidth sx={styles.showMoreButton} onClick={handleOnClickShowMore}>
        {t("showMore")}
      </Button>
    </Box>
  );
};

export default Trophies;
